import { React } from 'external/react'
import { FAIcon, styled } from 'external/material'
import { isUUID } from 'helpers/utils'

type LessonProps = {
  id: string
  name: string
  onDeleteClick: () => void
}

const StyledLesson = styled('div')(lessonStyles)

const Lesson = (props: LessonProps) => {
  const { id, name, onDeleteClick} = props
  return (
    <StyledLesson className="planrd-lesson">
      <div className="content">
        {!isUUID(id) && (<div className="id">{id}</div>)}
        {isUUID(id) && (<div className="id">Mi lección</div>)}
        <div className="name" title={name}>
          <p>{name}</p>
        </div>
      </div>
      <div className="actions">
        <div className="delete" onClick={onDeleteClick}>
          <FAIcon icon="trash" />
        </div>
      </div>
    </StyledLesson>
  )
}

function lessonStyles() {

  return {

    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: 15,
    borderBottom: 'solid 1px #e2ecf2',
    '&:last-child': {
      borderBottom: 'none'
    },

    '& .content': {
      cursor: 'default',
      flexGrow: 1,
      color: '#4e576e',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: 0,
      minHeight: '40px',
      maxHeight: '150px',

      '& > .id': {
        fontWeight: 'bold'
      },
      '& > .name': {
        color:'#838999',
        fontSize: '10.5pt',
        wordWrap: 'breakWord'
      },
    },

    '& .actions': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: '10px',
      '& .delete': {
        cursor: 'pointer',
        color: '#dd3636',
        backgroundColor: '#ededed',
        borderRadius: '50%',
        padding: '8px 9px',
        '&:hover': {
          transform: 'scale(1.10)'
        }
      }
      
    },
  }
}
export {Lesson as default}
